export const aciCloseCircle = {
    iconName: 'close-circle',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M12.998 23.25c6.213 0 11.25-5.037 11.25-11.25S19.211.75 12.998.75 1.748 5.787 1.748 12s5.037 11.25 11.25 11.25z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M8.498 16.5l8.999-9M17.498 16.5l-9-9',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
